import {AbstractMainPlugin} from "../AbstractMainPlugin";
import {Item} from "../../models/Item";
import {appInjector} from "../appInjector";
import {TimelineService} from "../../services/timeline/timeline.service";
import {debounceTime} from "rxjs/operators";


export class TimelinePlugin extends AbstractMainPlugin {

  private timelineService: TimelineService = appInjector.get(TimelineService);

  constructor(item:Item) {
    super(item);
    this.initListeners();
  }

  private initListeners(){

    this.timelineService.activeFrames.pipe(debounceTime(500)).subscribe((val)=>{
        let myTime = this.item.config.getInputProp('__timeline', 'value');
        if (myTime && myTime.length > 0 && this.timelineService.isActive) {
          let visibility = (val.indexOf(myTime) >= 0);
          this.setItemVisibilityComponent(visibility);
          this.item.setSidebarItemVisibility(visibility);
        } else {
          this.setItemVisibilityComponent(true);
          this.item.setSidebarItemVisibility(true);
        }
    });
  }

}
